import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiStepsWizard } from "../../../components/common/UiStepsWizard";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import { UiInput } from '../../../components/form/UiInput';
import { UiButtonPrimary } from '../../../components/form/UiButton';

export const HowIncentiveWorks = (props) => {

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-incentive-process-wrapper sb-wizard-section-wrapper">
                    <UiCol lg="8" className={props.className}>
                        <UiContentCol>
                            <UiCardTitle title="Quick Read: Tips to succeed" />
                            <p>This quick guide will help to get you up and running. Remember every day matters during the campaign period. So make the most of your earning potential and ACT NOW.
                            </p>
                            <UiStepsWizard
                                wizardData={props.wizardData}
                            />
                        </UiContentCol>
                    </UiCol>
                    <UiCol lg="4">
                        <div className="sb-how-incentive-works-code-entry sb-g-points">
                            <UiContentCol>
                                <UiCardTitle title="Realtime Code Entry" />
                                <p>Got a realtime code? Add it to you score total by entering it here:</p>
                                <UiInput placeholder="Insert code" />
                                <UiButtonPrimary btnName="Submit" />
                            </UiContentCol>
                        </div>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}


